import { render } from "./TnC.vue?vue&type=template&id=5e1c36a2"
import script from "./TnC.vue?vue&type=script&lang=js"
export * from "./TnC.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__